import Styles from 'src/components/Styles';

export function getHeaderBackground(content: JSX.Element): JSX.Element {
  return content;
}

export function headerFontSize(): number {
  return Styles.Fonts.headerFont;
}

export function subHeaderFontSize(): number {
  return Styles.Fonts.sectionHeader;
}

export function headerContainerStyleDescriptor(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    safeArea: {
      backgroundColor: Styles.Colors.Canteen.darkGreen,
    },
    container: {
      flex: 1,
      backgroundColor: '#F1f5f5',
      flexDirection: 'column',
    },
    headerTextStyle: {
      textAlign: 'left',
      fontSize: headerFontSize(),
      color: Styles.Colors.Canteen.lightGreen,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.robotoRegular,
      height: 34,
      verticalAlign: 'middle',
    },
  };
}

export function subHeaderContainerStyleDescriptor(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    subHeaderTextStyle: {
      fontSize: subHeaderFontSize(),
      fontWeight: '700',
    },
  };
}

export function getBackIconColor(transparent: boolean): string {
  return transparent
    ? Styles.Colors.PayNew.black01
    : Styles.Colors.Canteen.lightGreen;
}

export default {
  getHeaderBackground,
  headerContainerStyleDescriptor,
  getBackIconColor,
  headerFontSize,
  subHeaderFontSize,
  subHeaderContainerStyleDescriptor,
};
